import Home from '../components/Home/Home'
import MyStory from '../components/MyStory/MyStory'
import Skills from '../components/Skills/Skills'
import Experience from '../components/Experience/Experience'
import FeaturedProjects from '../components/FeaturedProjects/FeaturedProjects'
import Projects from '../components/Projects/Projects'
import Contact from '../components/Contact/Contact'

const HomePage = ({ visitorSlug }) => (
  <>
    <Home visitorSlug={visitorSlug} />
    <MyStory />
    <Skills />
    <Experience />
    <FeaturedProjects />
    <Projects />
    <Contact />
  </>
)

export default HomePage
